import {
  createJourneyElement,
  createJourneyElementCommon,
  createPersonalDetails,
  createRegulatoryDetail,
  createRegulatoryDetailsReplyData,
  EligibilityRepository,
  MockJourneyElementCommon,
  MockRegulatoryDetailsReplyData,
} from '@dapi/sdk/spec';
import {
  address,
  countryExitDate,
  defaultPhoneNumber,
  missingExitDate,
  missingIdentityDocumentChoice,
  missingPersonalDetailsChoice,
  namedTraveler,
  passport,
  personalDetails,
  visa,
} from '../dictionaries';
import {
  journeys,
} from './mock-journeys';

export const defaultRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: true,
    travelerId: namedTraveler.id,
    traveler: namedTraveler,
    storedDetails: [
      createRegulatoryDetail({
        template: {
          personalDetails
        }
      }),
      createRegulatoryDetail({
        template: {
          document: passport
        }
      }),
      createRegulatoryDetail({
        template: {
          document: visa
        }
      }),
      createRegulatoryDetail({
        template: {
          address: address
        }
      }),
      createRegulatoryDetail({
        template: {
          phoneNumber: defaultPhoneNumber
        }
      })
    ]
  }
});

export const defaultRegulatoryDetailsForDomesticRoute: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: true,
    travelerId: namedTraveler.id,
    traveler: namedTraveler,
    storedDetails: [
      createRegulatoryDetail({
        template: {
          personalDetails
        }
      })
    ]
  }
});

export const incompletePersonalRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: false,
    travelerId: namedTraveler.id,
    traveler: namedTraveler,
    storedDetails: [
      createRegulatoryDetail({
        template: {
          personalDetails: createPersonalDetails({
            template: {
              birthDate: namedTraveler.dateOfBirth
            }
          })
        }
      })
    ],
    missingDetails: [missingPersonalDetailsChoice]
  }
});

export const incompleteIdentityRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: false,
    travelerId: namedTraveler.id,
    traveler: namedTraveler,
    storedDetails: [createRegulatoryDetail({
      template: {
        personalDetails
      }
    })],
    missingDetails: [missingIdentityDocumentChoice]
  }
});

export const incompleteExitDateRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: false,
    travelerId: namedTraveler.id,
    traveler: namedTraveler,
    storedDetails: [createRegulatoryDetail({
      template: {
        personalDetails
      }
    })],
    missingDetails: [missingExitDate]
  }
});

export const completeExitDateRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: true,
    travelerId: namedTraveler.id,
    traveler: namedTraveler,
    storedDetails: [createRegulatoryDetail({
      template: {
        personalDetails,
        travelerQuestionnaireAnswer: countryExitDate
      }
    })]
  }
});

export const missingRegulatoryJourneyElementCommon: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        ...journeys[0].journeyElements[0].journeyElement,
        acceptanceEligibility: EligibilityRepository.REGULATORY
      }
    })
  }
});
